import axios from '@/utils/request'

export const paymentDetail = (params = {}) => axios.get('/payment/detail', { params }).then(res => res.data)

export const submitReceiptEmail = (params = {}) => axios.post('/payment/stripe/charge/receipt', params).then(res => res.data)

export const redirect = (params = {}) => axios.post('/payment/stripe/3d/redirect', params).then(res => res.data)

export const charge = (params = {}) => axios.post('/payment/stripe/3d/charge', params).then(res => res.data)
